<template>
    <div>
        <template>

            <div class="">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Loan Details </h1>
                    <div class="searching float-right">
                        <input id="customSearch" type="text" class="form-control search" name="" />
                    </div>
                </div>
                <table id="dt" class="table table-responsive-xl" style="width:100%">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Mobile No</th>
                            <th>CNIC</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>

                    </tbody>
                </table>
	        </div>
        </template>
    </div>
</template>
<script>
var myTable = null;
    export default {
        data() {
            return {
                canView : null,
                data: [],
                dataIndex: 0,
            };
        },
    	filters: {

        },

        created() {
        },

        mounted() {
            var that = this;
            this.$Progress.start();
            this.getCompanyId();
            window.showAllowedLoan = function (index) {
                var data = that.data[index];
                that.$router.push('/loanDetail/'+data.payroll_user_id);
            }
        },

        methods: {
            getCompanyId(){
                var that = this;
                myTable =  $('#dt').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getCompanyLoan",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) {
                            // type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'mobile_no'},
                        {data: 'cnic'},
                        {render: function(data,type,full){
                            that.data[that.dataIndex] = full;
                            var btn = '<a href="javascript:void(0);" onclick="showAllowedLoan('+that.dataIndex+')" data-toggle="tooltip" data-placement="top" title="View" class="action view"><i class="fas fa-eye"></i></a>'
                            that.dataIndex += 1;
                            return btn;

                        }},

                    ],
                    drawCallback: function(settings){
                         that.dataIndex = 0;
                         $(".action").tooltip();
                    },
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 3 ]
                    }],
                    "order": [[ 0, "desc" ]],
                });
                $('#customSearch').on( 'keyup', function () {
                    myTable.search(this.value).draw();
                });
            },
        }
    }
</script>
